import React from 'react'
import styled from 'styled-components'
import { InputAttributes, PatternFormat } from 'react-number-format'
import { InputStyle } from './input'

const StyledPhoneInput = styled(PatternFormat)`
  ${InputStyle}
`

const PhoneInput = ({
  onValueChange,
  value,
  invalid,
  ...props
}: {
  onValueChange: ({
    formattedValue,
    value,
    floatValue,
  }: {
    formattedValue: string
    value: string
    floatValue: number
  }) => void
  value: string
  invalid?: boolean
} & InputAttributes) => {
  return (
    <StyledPhoneInput
      type="tel"
      format="(###) ###-####"
      placeholder="(###) ###-####"
      onValueChange={onValueChange}
      value={value}
      invalid={invalid ? true : undefined}
    />
  )
}

export default PhoneInput
